var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConcreteMixerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_873_12280)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_873_12280",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9766 19.9803V0.0194111H0.015625V19.9803H19.9766Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.0390625
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_873_12280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7693 12.2001L7.01681 11.4193C6.99458 11.4162 6.97325 11.4085 6.95427 11.3965L2.04567 8.29703C1.98337 8.25769 1.95692 8.18023 1.98212 8.11101L3.74091 3.27879C3.7661 3.20957 3.83614 3.16726 3.90915 3.17718L9.66161 3.95804C9.68388 3.96105 9.70524 3.96882 9.72419 3.98078L14.6328 7.08027C14.6951 7.11961 14.7216 7.19703 14.6963 7.26625L12.9376 12.0985C12.9124 12.1677 12.8423 12.21 12.7693 12.2001Z",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15426 3.75325L5.66797 10.5841",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.18 7L8.49609 11.6201",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9848 4.77787L10.0547 7.33295",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.80468 12.2017L0.63792 8.99541C0.612881 8.92666 0.612881 8.85088 0.63792 8.78174L2.38085 3.99346C2.43987 3.83135 2.61917 3.74775 2.78124 3.80674L3.17269 3.94932C3.33479 4.0083 3.41839 4.1876 3.3594 4.34971L1.74608 8.78174C1.72108 8.85088 1.72108 8.92666 1.74608 8.99541L2.91331 12.2017",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.873047 14.3826V12.5142C0.873047 12.3419 1.01289 12.2017 1.18555 12.2017H14.7105",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7129 14.3826V6.68413C14.7129 6.51147 14.8527 6.37163 15.0254 6.37163H17.2351C17.3582 6.37163 17.4703 6.4439 17.5203 6.55679L19.118 10.1357C19.1227 10.1458 19.125 10.1568 19.125 10.1677V14.3826",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9957 7.62158H16.3926C16.2199 7.62158 16.0801 7.76143 16.0801 7.93408V9.72119C16.0801 9.89385 16.2199 10.0337 16.3926 10.0337H19.0723",
    stroke: "#FEB111",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1242 12.3275H17.7461C17.6598 12.3275 17.5898 12.2575 17.5898 12.1712V11.1712C17.5898 11.0849 17.6598 11.015 17.7461 11.015H19.1242",
    stroke: "#FEB111",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 14.3826H19.548C19.6344 14.3826 19.7043 14.4525 19.7043 14.5388V15.5935C19.7043 15.6798 19.6344 15.7498 19.548 15.7498H18.0039",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7641 14.3826H10.3086",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 15.7498H10.3086",
    stroke: "#FEB111",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7641 15.7498H12.9961",
    stroke: "#FEB111",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98945 15.7498H0.445312C0.358984 15.7498 0.289062 15.6798 0.289062 15.5935V14.5388C0.289062 14.4525 0.358984 14.3826 0.445312 14.3826H1.98945",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06879 14.3826H5.23047",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.06879 15.7498H5.23047",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4453 15.0663C10.4453 16.0371 9.65832 16.8241 8.6875 16.8241C7.71668 16.8241 6.92969 16.0371 6.92969 15.0663C6.92969 14.0955 7.71668 13.3085 8.6875 13.3085C9.65832 13.3085 10.4453 14.0955 10.4453 15.0663Z",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6875 15.6522C8.36441 15.6522 8.10156 15.3894 8.10156 15.0663C8.10156 14.7432 8.36441 14.4803 8.6875 14.4803C9.01059 14.4803 9.27344 14.7432 9.27344 15.0663C9.27344 15.3894 9.01059 15.6522 8.6875 15.6522Z",
    stroke: "#FEB111",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1406 15.0663C18.1406 16.0371 17.3536 16.8241 16.3828 16.8241C15.412 16.8241 14.625 16.0371 14.625 15.0663C14.625 14.0955 15.412 13.3085 16.3828 13.3085C17.3536 13.3085 18.1406 14.0955 18.1406 15.0663Z",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3828 15.6522C16.0597 15.6522 15.7969 15.3894 15.7969 15.0663C15.7969 14.7432 16.0597 14.4803 16.3828 14.4803C16.7059 14.4803 16.9688 14.7432 16.9688 15.0663C16.9688 15.3894 16.7059 15.6522 16.3828 15.6522Z",
    stroke: "#FEB111",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36719 15.0663C5.36719 16.0371 4.5802 16.8241 3.60938 16.8241C2.63855 16.8241 1.85156 16.0371 1.85156 15.0663C1.85156 14.0955 2.63855 13.3085 3.60938 13.3085C4.5802 13.3085 5.36719 14.0955 5.36719 15.0663Z",
    stroke: "#FEB111",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 15.6522C3.28629 15.6522 3.02344 15.3894 3.02344 15.0663C3.02344 14.7432 3.28629 14.4803 3.60938 14.4803C3.93246 14.4803 4.19531 14.7432 4.19531 15.0663C4.19531 15.3894 3.93246 15.6522 3.60938 15.6522Z",
    stroke: "#FEB111",
    strokeWidth: 0.585937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_873_12280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcreteMixerIcon);
export default __webpack_public_path__ + "static/media/concrete-mixer-icon.30ccb0ed25bc80de79c49da94494e232.svg";
export { ForwardRef as ReactComponent };